import { Component } from '@angular/core';

@Component({
  selector: 'app-sites-grid-skeleton',
  templateUrl: './sites-grid-skeleton.component.html',
  styleUrls: ['./sites-grid-skeleton.component.scss']
})
export class SitesGridSkeletonComponent {
  // Propriété pour générer les cartes de sites
  sitesCards = [0, 1];
}
